const setTouchedForErrors = (errors: any, setTouched: any) => {
  const allKeys = Object.keys(errors);
  if (allKeys.length > 0) {
    setTouched(
      allKeys.reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {} as any),
    );
    return true;
  }
  return false;
};

export default setTouchedForErrors;
